export default __webpack_public_path__ + "static/media/Drama.ee037083.jpg";